
const regNumber = eval('/^\\d+$/')
const regText = eval('/[a-z]/') 
const reqEmail = eval('/[A-Z0-9a-z.@_-]/')

export const preventNumber = (e) => {  
    if( e.key
        &&e.keyCode !== 8 
        && e.keyCode !==46 
        && e.keyCode !==13 
        &&!regNumber.test(e.key)
    ){
        e.preventDefault()
        return
    }
} 

export const preventEmail = (e) => {  
    if (e.key&&e.keyCode!==8&&!e.key.match(reqEmail)) {
        e.preventDefault();
        return
    }
}

export const preventUsername = (e) => { 
    if (e.key&&!e.key.match(regText)&&e.keyCode!==8&&!regNumber.test(e.key)) {
        e.preventDefault();
        return
    }
} 